module.exports = __webpack_public_path__ + "static/media/S1N8-6.8cf09154.svg";